import { ExpressionSpecification } from "maplibre-gl";
import { SchoolType } from "../editing_planning/data_requirements";
import { ScenarioKey } from "../types/data/api";
// import { ScenarioKey } from "../types/data/api";

export const SCH_LEVELS = {
  ES: "ES",
  MS: "MS",
  HS: "HS",
};
//
export const FILTER_XWALK: { [key in SchoolType]: ExpressionSpecification } = {
  ES: [
    "in",
    ["get", "school_level"],
    ["literal", ["ES", "ES/MS/HS", "ES/MS", "K-8"]],
  ], //
  MS: [
    "in",
    ["get", "school_level"],
    ["literal", ["MS", "ES/MS", "MS/HS", "ES/MS/HS"]],
  ], // ,
  HS: ["in", ["get", "school_level"], ["literal", ["HS", "MS/HS", "ES/MS/HS"]]],
};

export const ZONE_FILTER_XWALK = {
  ES: ["get", "es_color"],
  MS: ["get", "ms_color"],
  HS: ["get", "hs_color"],
};

export const SCENARIO_FILTER_XWALK: {
  [key in ScenarioKey]: ExpressionSpecification;
} = {
  0: ["==", ["get", "scenario_id"], 0],
  11: ["==", ["get", "scenario_id"], 1],
  2: ["==", ["get", "scenario_id"], 2],
  3: ["==", ["get", "scenario_id"], 3],
  4: ["==", ["get", "scenario_id"], 4],
};
